import Markdown from "react-markdown";

// Steps support paragraphs and lists; summaries stay inline inside typography.
export const ActivityText = ({ children, block = false }: { children: string; block?: boolean }) => (
  <Markdown
    allowedElements={["strong", "em", "code", "br", ...(block ? ["p", "ul", "ol", "li"] : [])]}
    unwrapDisallowed
  >
    {children}
  </Markdown>
);
